<template>
  <div
    class="release-modal-wrapper">
    <modal
      name="releaseDateModal"
      :adaptive="true"
      height="auto"
      width="1000px"
      class="u-text-align-center release-modal-scrooler"
      @closed="hide">
      <div
        class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">
          {{ provider.name }}
        </h3>
        最短リリース日: {{ provider.min_release_date | formatDate('YYYY年MM月DD日') }}
      </div>
      <table class="my-release-list__table">
        <thead class="my-release-list__thead">
          <tr>
            <th class="my-release-list__cell-no">No.</th>
            <th class="my-release-list__cell-title">タイトル</th>
            <th class="my-release-list__cell-date">リリース日</th>
          </tr>
        </thead>
        <tbody
          v-for="(disc, index) in discs"
          :key="index"
          class="my-release-list__tbody">
          <tr
            v-for="(track, index2) in disc.tracks"
            :key="index2">
            <td>
              {{ index2 + 1 }}
            </td>
            <td style="text-align: left">
              {{ track.title_ja }}
            </td>
            <td>
              <date-select
                v-if="track.restrictions"
                v-model="track.restrictions[providerKey]"
                :min-date="minDate"
                :max-date="maxDate" />
            </td>
          </tr>
        </tbody>
      </table>

      <div class="release-date-modal">
        <div class="c-btn-wrap">
          <a
            href="#"
            class="c-btn c-btn--close c-btn--narrow js-modal-close"
            @click.prevent="hide">
            閉じる
            <span class="c-btn__icon-close">
              <span></span>
            </span>
          </a>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>

import moment from 'moment'
import DateSelect from '../../DateSelect'

export default {
  name: 'ReleaseDateModal',
  components: { DateSelect },
  props: {
    providerKey: {
      type: String,
      required: true,
    },
    provider: {
      type: Object,
      required: true,
    },
    discs: {
      type: Array,
      required: true,
    },
    isShown: {
      type: Boolean,
      default: false,
    },
    minDate: {
      type: [String, Object],
      default: () => '1970-01-01',
    },
    maxDate: {
      type: [String, Array],
      default: () => moment().format('YYYY-MM-DD'),
    },
  },
  data() {
    return {
      items: [],
    }
  },
  watch: {
    isShown() {
      if (this.isShown) {
        this.show()
      } else {
        this.hide()
      }
    },
  },
  mounted() {
  },
  methods: {
    show() {
      this.$modal.show('releaseDateModal')
    },
    hide() {
      this.$modal.hide('releaseDateModal')
      this.$emit('closed')
    },
  },
}
</script>

<style scoped>
.release-date-modal {
  padding: 2vmin;
}
@media screen and (min-width: 896px) {
  .release-date-modal {
    max-height: 80vh!important;
  }
  .my-release-list__cell-no {
    width: 80px;
  }
  .my-release-list__cell-date {
    width: 221px;
  }
  .release-modal-scrooler {
    overflow: scroll;
  }
}
@media screen and (max-width: 895px) {
  .release-date-modal {
    height: 90vh!important;
  }
  .my-release-list__cell-no {
    width: 28vw;
  }
  .my-release-list__cell-date {
    width: 37.33333vw;
  }
  .release-modal-scrooler {
    overflow: scroll;
  }
}
</style>
